import {
    DeleteOutlined,
    DownloadOutlined,
    EyeInvisibleOutlined,
    EyeOutlined,
    LockOutlined,
    PlusOutlined,
    RedoOutlined,
    SearchOutlined,
    UnlockOutlined,
} from '@ant-design/icons';
import {
    Alert,
    Button,
    Col,
    Form,
    Input,
    Modal,
    notification,
    Pagination,
    Radio,
    Row,
    Select,
    Space,
    Switch,
    Table,
    Tag,
    Upload,
} from 'antd';
import {
    useContext,
    useEffect,
    useState,
} from 'react';
import { CounterContext } from 'redux/Golbalvalues';
import styled from 'styled-components';

const { Option } = Select

import 'styleLess/signature/management.scss';

import {
    accountUnLock,
    addAccount,
    changePassword,
    deleteImageAccount,
    editAccountV2,
    exportAccount,
    getAccountByIdV2,
    getCompanyWithLinkV2,
    getResultAccountList,
    getResultBUV2,
    getResultRoleList,
    saveImageAccount,
    updateCompanyLink,
} from 'api/MasterData/userManagement';

import { getPermissionControl } from 'api/Admin/rolePermission';

import DeleteAccount from 'common/Management/deletenocheck';
import Importfile from 'common/Management/Importfile';
import { getCookie, setCookie } from 'helper/cookie';
import ellipse from 'icons/Ellipse1.svg';
import loadingIcons from 'icons/three-dots.svg';
import lang from 'lang/en';

import { CheckCircleOutlined } from '@ant-design/icons';
import { PasswordInput } from 'antd-password-input-strength';
import { getDataCompany, getDataCompany_Level_v2 } from 'api/Admin/company';
import { getFileSecurityFromApi } from 'api/OpenFile';
import zxcvbn from 'zxcvbn';
const EditUpload = styled(Upload)``
const BusinessContainer = styled.div``
const EmptyContainer = styled.div``
const Container = styled.div``
const Header = styled.div``
const Body = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
const initalState = {
  data: [],
  isLoading: true,
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    // showQuickJumper: 1,
    showSizeChanger: true,
    showTotal: (total, range) => showToalPagination(total, range),
  },
}
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}

const initialState = {
  switchAddTaskComponents: '',
  isLoading: true,
}
const Bodier = styled.div``
const UserManagement = (props) => {
  const { today } = props
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const userID = getCookie('userID')
  const word = lang[language]
  const [displayPassword, setDisplayPassword] = useState(false)
  const [dataAccountList, setDataAccountList] = useState([])
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [pagination, setPagination] = useState(initalState.pagination)
  const [visible, setVisible] = useState(false)
  const [stateDrawer, setStateDrawer] = useState('')
  const [titleDrawer, setTitleDrawer] = useState('')
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [dataEdit, setDataEdit] = useState()
  const [hiddenError, setHiddenError] = useState(true)
  const [passmessagevisible, setPassmessagevisinle] = useState(true)
  const [filterTarget, setFilterTarget] = useState({
    name: '',
    username: '',
    role: '',
    last_login: '',
    status: '',
  })
  const [scorePassword, setScorePassword] = useState({ nameScore: '', colorScore: '' })

  //search
  const [searchedColumn, setSearchedColumn] = useState('')
  const [searchText, setSearchText] = useState('')
  const [form] = Form.useForm()
  const [form2] = Form.useForm()
  const [form3] = Form.useForm()

  //รูป
  const [state, setState] = useState('')
  const [logoName, setlogoName] = useState('')

  //import file
  const [visibleModal, setVisibleModal] = useState(false)

  //export file
  const [visibleExport, setVisibleExport] = useState(false)

  //tab
  const [mode, Setmode] = useState(true)
  const [OneUnitFocus, setOneUnitFocus] = useState(1)

  //date save
  const [dataUser, setDataUser] = useState([])

  //advance company
  const [visibleAdvance, setVisibleAdvance] = useState(false)
  const [dataSelectCompany, setDataSelectCompany] = useState()
  const [accountLinkValue, setAccountLinkValue] = useState([])
  const [companyAdvanceValue, setCompanyAdvanceValue] = useState([])
  const [disableSelectAdvance, setDisableSelectAdvance] = useState(true)

  //lock user
  const [userLock, setUserLock] = useState(false)

  //powerbi
  const [visiblePoverBI, setVisiblePoverBI] = useState(false)

  //tabs
  const handleSelect = (check) => {
    if (check == 1) {
      setVisiblePoverBI(false)
      setVisibleAdvance(false)
      Setmode(true)
      setOneUnitFocus(1)
      return swithCaseAddTaskFunction('')
    }
    if (check == 3) {
      Setmode(true)
      setOneUnitFocus(3)
      return swithCaseAddTaskFunction('company')
    }
  }

  const swithCaseAddTaskFunction = (type) => {
    setSwitchAddTaskComponents(type)
  }

  const [switchAddTaskComponents, setSwitchAddTaskComponents] = useState(
    initialState.switchAddTaskComponents,
  )

  //select
  const [childrenRole, setChildrenRole] = useState([])
  const [dataBU, setDataBU] = useState([])

  //err
  const [wordError, setWordError] = useState()
  const [passwordError, setPasswordError] = useState(String)

  const [childrenDefaultRole, setChildrenDefaultRole] = useState([])

  const [disableSelectRole, setDisableSelectRole] = useState(true)

  //checkrole
  const { adminPermission, getPermissionAdmin } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const roleUser = getCookie('roleUser')
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 19) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  function handleChangeSelectRole(value, name) {
    if (value == '') {
      setDisableSelectRole(true)
    } else {
      setDisableSelectRole(false)
    }
    form.setFieldsValue({
      DefaultRole: null,
    })
    setChildrenDefaultRole(name)
  }

  const DeleteImageAccount = () => {
    const data = {
      id: stateDrawer == 'add' ? 9999999999999 : dataEdit.id,
    }

    try {
      deleteImageAccount({
        params: data,
        token: token,
      }).then((response) => {
        if (response.status === 200) {
          getDataAccountList(pagination.current)
          setState({
            imageUrl: null,
          })
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const [disableNext, setDisableNext] = useState(false)
  const [checkPasswordEdit, setCheckPasswordEdit] = useState('')

  const onChangePassword = (e) => {
    let value = e.target.value
    let score = value.length == 0 ? -1 : zxcvbn(value).score

    if (score == -1) {
      setScorePassword({ nameScore: '', colorScore: '' })
    } else if (score == 0) {
      setScorePassword({ nameScore: 'Weak', colorScore: 'rgb(255, 64, 51)' })
    } else if (score == 1) {
      setScorePassword({ nameScore: 'Okay', colorScore: 'rgb(254, 148, 13)' })
    } else if (score == 2) {
      setScorePassword({ nameScore: 'Good', colorScore: 'rgb(255, 217, 8)' })
    } else if (score == 3) {
      setScorePassword({ nameScore: 'Strong', colorScore: 'rgb(203, 225, 29)' })
    } else if (score == 4) {
      setScorePassword({ nameScore: 'Stronger', colorScore: 'rgb(110, 204, 58)' })
    }

    if (score < 3) {
      setDisableNext(true)
    } else {
      setDisableNext(false)
    }

    if (stateDrawer == 'edit' && score == -1) {
      setDisableNext(false)
      setCheckPasswordEdit(false)
    } else {
      setCheckPasswordEdit(true)
    }
  }

  const validatePassword = (_, value, callback) => {
    const validList = [
      {
        pattern: '.{10,}',
        message: 'Password must be at least 10 characters.',
      },
      {
        pattern: '.*(\\d{1,}).*',
        message: 'Password must have at least 1 digit',
      },
      {
        pattern: '.*([a-z]{1,}).*',
        message: 'Password must have at least 1 lower case character',
      },
      {
        pattern: '.*([A-Z]{1,}).*',
        message: 'Password must have at least 1 upper case character',
      },
      {
        pattern: '(?=.*?[#?!@_$%^&*-])',
        message: 'Password must have at least 1 special character',
      },
    ]

    validList.forEach((regex) => {
      if (value && !value.match(regex.pattern)) {
        callback(regex.message)
      }
    })
    callback()
  }
  const displayEffectUserType = (e) => {
    const usertype = e.target.value
    setDisplayPassword(usertype !== 'IN')
  }
  const renderComponents = () => {
    switch (switchAddTaskComponents) {
      case 'company':
        return (
          <Form
            className="disable-page"
            form={form2}
            onFinish={onFinish2}
            layout="vertical"
          >
            <fieldset disabled={disablePage}>
              <Form.Item
                id="UserName"
                name="UserName"
                label={<h4>{word['Username']}</h4>}
              >
                <Input
                  size="large"
                  // value={dataUser.Username}
                  disabled
                  placeholder="Please enter username"
                />
              </Form.Item>

              <Form.Item
                id="Company"
                name="Company"
                label={<h4>{word['Business']}</h4>}
                className="customValidation"
                validateStatus={mainBusinessErrors.Company ? 'error' : undefined}
                help={mainBusinessErrors.Company}
                rules={[
                  {
                    required: true,
                    message: 'Please enter business',
                  },
                ]}
              >
                <Select
                  id="selectcompany_code"
                  size="large"
                  placeholder="Business Code"
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  onChange={onChangeCompany}
                  disabled={disablePage}
                >
                  {dataOptionCompany.map((item) => (
                    <Option value={item.code}>
                      {item.code} {language == 'en' ? item.name_en : item.name_th}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                id="Operation"
                name="Operation"
                label={<h4>{word['Operation']}</h4>}
                className="customValidation"
                validateStatus={mainBusinessErrors.Operation ? 'error' : undefined}
                help={mainBusinessErrors.Operation}
                rules={[
                  {
                    required: true,
                    message: 'Please enter operation',
                  },
                ]}
              >
                <Select
                  id="selectoperation_code"
                  size="large"
                  placeholder="Operation Code"
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  onChange={onChangeOperation}
                  disabled={disablePage ? true : disableSelectOperation}
                >
                  {dataOptionOperation.map((item) => (
                    <Option value={item.code}>
                      {item.code} {language == 'en' ? item.name_en : item.name_th}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                id="SubOperation"
                name="SubOperation"
                label={<h4>{word['Sub_Operation']}</h4>}
                className="customValidation"
                validateStatus={mainBusinessErrors.SubOperation ? 'error' : undefined}
                help={mainBusinessErrors.SubOperation}
                rules={[
                  {
                    required: true,
                    message: 'Please enter project type',
                  },
                ]}
              >
                <Select
                  id="selectsub_operation_code"
                  size="large"
                  placeholder="Project type Code"
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  disabled={disablePage ? true : disableSelectSubOperation}
                  onChange={() => clearMainBusinessErrors(['SubOperation'])}
                >
                  {dataOptionSubOperation.map((item) => (
                    <Option value={item.code}>
                      {item.code} {language == 'en' ? item.name_en : item.name_th}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item name="Account_link" label={<h4>Link Business</h4>}>
                <Select
                  disabled={disablePage}
                  mode="multiple"
                  size="large"
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Select link business"
                  optionLabelProp="label"
                  value={accountLinkValue}
                  onChange={onChangeAccountLink}
                >
                  {stateDrawer === 'edit' &&
                    dataEdit?.company_list?.map((item) => {
                      const companyLabel = `${item.company_code} ${language == 'en' ? item.company_name_en : item.company_name_th
                        }`
                      return (
                        <Option
                          key={item.company_id || item.company_code}
                          value={item.company_code}
                          label={companyLabel}
                          style={{ display: 'none' }}
                        >
                          {companyLabel}
                        </Option>
                      )
                    })}
                  {stateDrawer === 'edit' &&
                    dataEdit?.data?.main_company_code &&
                    !dataEdit?.company_list?.some(
                      (item) => item.company_code == dataEdit.data.main_company_code,
                    ) && (
                      <Option
                        value={dataEdit.data.main_company_code}
                        label={`${dataEdit.data.main_company_code} ${dataEdit.data.main_company_name}`}
                        style={{ display: 'none' }}
                      >
                        {dataEdit.data.main_company_code}{' '}
                        {dataEdit.data.main_company_name}
                      </Option>
                    )}
                  {dataOptionCompany.map((item) => {
                    if (item.code != dataSelectCompany && !isInactiveCompany(item)) {
                      const companyLabel = `${item.code} ${language == 'en' ? item.name_en : item.name_th}`
                      return (
                        <Option value={item.code} label={companyLabel}>
                          {companyLabel}
                        </Option>
                      )
                    }
                  })}
                </Select>
              </Form.Item>

              <div hidden={!visibleAdvance}>
                <h2 style={{ color: '#127EC3' }}>{word['Advanced_Filter']}</h2>
                <p style={{ marginTop: 8, color: '#FF6258' }}>
                  {
                    word[
                    'Please_select_additional_business_that_you_would_like_to_be_displayed_in_the_Executive_Dashboard'
                    ]
                  }
                </p>
                <Form.Item
                  style={{ marginTop: 24 }}
                  id="CompanyAdvance"
                  name="CompanyAdvance"
                  label={<h4>{word['Business']}</h4>}
                >
                  <Select
                    disabled={disablePage ? true : disableSelectAdvance}
                    mode="multiple"
                    size="large"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="Please select business"
                    optionLabelProp="label"
                    value={companyAdvanceValue}
                    onChange={onChangeCompanyAdvance}
                  >
                    {companyAdvanceValue.map((companyCode) => {
                      const companyOptions = [
                        ...dataOptionCompanyMapping,
                        ...dataOptionCompany,
                        ...(dataEdit?.company_list || []),
                      ]
                      const selectedCompanyCode = getCurrentCompanyCode()
                      const hasActiveOption = dataOptionCompany.some(
                        (item) =>
                          item.code == companyCode &&
                          item.code != selectedCompanyCode &&
                          !isInactiveCompany(item),
                      )
                      const company = companyOptions.find(
                        (item) => getCompanyCode(item) == companyCode,
                      )

                      if (!company || hasActiveOption) {
                        return null
                      }

                      const companyLabel = getCompanyLabel(company)
                      return (
                        <Option
                          key={`company-advance-selected-${companyCode}`}
                          value={companyCode}
                          label={companyLabel}
                          style={{ display: 'none' }}
                        >
                          {companyLabel}
                        </Option>
                      )
                    })}
                    {stateDrawer === 'edit' &&
                      dataEdit?.company_list?.map((item) => {
                        const companyLabel = `${item.company_code} ${language == 'en' ? item.company_name_en : item.company_name_th
                          }`
                        return (
                          <Option
                            key={item.company_id || item.company_code}
                            value={item.company_code}
                            label={companyLabel}
                            style={{ display: 'none' }}
                          >
                            {companyLabel}
                          </Option>
                        )
                      })}
                    {stateDrawer === 'edit' &&
                      dataEdit?.data?.main_company_code &&
                      !dataEdit?.company_list?.some(
                        (item) => item.company_code == dataEdit.data.main_company_code,
                      ) && (
                        <Option
                          value={dataEdit.data.main_company_code}
                          label={`${dataEdit.data.main_company_code} ${dataEdit.data.main_company_name}`}
                          style={{ display: 'none' }}
                        >
                          {dataEdit.data.main_company_code}{' '}
                          {dataEdit.data.main_company_name}
                        </Option>
                      )}
                    {dataOptionCompany.map((item) => {
                      if (item.code != dataSelectCompany && !isInactiveCompany(item)) {
                        const companyLabel = `${item.code} ${language == 'en' ? item.name_en : item.name_th}`
                        return (
                          <Option value={item.code} label={companyLabel}>
                            {companyLabel}
                          </Option>
                        )
                      }
                    })}
                  </Select>
                </Form.Item>
              </div>
            </fieldset>
          </Form>
        )
      default:
        return (
          <Form
            className="disable-page addUserDrawer"
            form={form}
            layout="vertical"
            onFinish={onFinish}
          // onFinishFailed={onFailed}
          // hideRequiredMark
          >
            <fieldset disabled={disablePage}>
              <div
                className="fix-props-error"
                hidden={hiddenError}
                style={{ marginBottom: 10 }}
              >
                <Alert message={wordError} type="error" showIcon />
              </div>
              <div
                className="fix-props-error"
                hidden={passmessagevisible}
                style={{ marginBottom: 10 }}
              >
                <Alert
                  message={
                    passwordError === '2012'
                      ? 'The new password cannot be same as current password. Please try again.'
                      : passwordError === '2007'
                        ? 'The current password is incorrect. Please try again.'
                        : 'The password is too easy to guess. Please try again.'
                  }
                  type="error"
                  showIcon
                />
              </div>
              <Row justify="space-between">
                <Col>
                  <h4 className="label">{word['Avatar_optional']}</h4>
                  <Form.Item name="img">
                    {imageUrl ? (
                      <div className="new-content-upload">
                        <div className="start-content">
                          <div>
                            <img className="img-size" src={imageUrl} alt="avatar"></img>
                          </div>
                          <div className="middle-content">
                            <div className="mc-l">
                              <p className="title-avatar">{logoName}</p>
                              <CheckCircleOutlined className="icon-checkcircleoutlined" />
                            </div>
                            <EditUpload
                              className="avatar-upload-container"
                              action={logoUpload}
                              name="uploadfile"
                              listType="picture-card"
                              showUploadList={false}
                              beforeUpload={beforeUpload}
                              onChange={handleChange}
                            // disabled={role}
                            >
                              <span style={{ color: '#127ec3' }} onChange={handleChange}>
                                {word['Click_to_Change_Image_File']}
                              </span>
                            </EditUpload>
                          </div>
                        </div>
                        <div className="end-content" hidden={disablePage}>
                          <DeleteOutlined
                            onClick={() => DeleteImageAccount()}
                            className="icon-delete"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="new-content-upload">{uploadButton}</div>
                    )}

                    {/* <Document
                visible={isModalVisible}
                setVisible={setIsModalVisible}
                idEditPRJ={idEditPRJ}
                kind={14}
                getListFileDoc={getListFileDoc}
              /> */}
                  </Form.Item>
                </Col>
                <Col>
                  <div
                    className="unLockUser animationUnLockUser"
                    onClick={onClickUnLock}
                    style={{ display: userLock ? '' : 'none' }}
                  >
                    <LockOutlined className="iconLock" />
                    <UnlockOutlined className="iconUnLock" />
                    <p className="title">Unlock User</p>
                  </div>
                </Col>
              </Row>
              <Form.Item
                id="Username"
                name="Username"
                label={<h4>{word['Username']}</h4>}
                className="customValidation"
                rules={[
                  {
                    whitespace: true,
                    required: true,
                    message: 'Please enter username',
                  },
                ]}
              >
                <Input id="username" size="large" placeholder="Please enter username" />
              </Form.Item>
              {/* fullname th */}
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    id="Name_TH"
                    name="Name_TH"
                    label={<h4>Name (TH)</h4>}
                    className="customValidation"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Please enter name th',
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Please enter name th" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    id="Lastname_TH"
                    name="Lastname_TH"
                    label={<h4>Lastname (TH)</h4>}
                    className="customValidation"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Please enter last name th',
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Please enter last name th" />
                  </Form.Item>
                </Col>
              </Row>
              {/* fullname en */}
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    id="Name"
                    name="Name"
                    label={<h4>Name (EN)</h4>}
                    className="customValidation"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Please enter name en',
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Please enter name en" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    id="LastName"
                    name="LastName"
                    label={<h4>Lastname (EN)</h4>}
                    className="customValidation"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Please enter last name en',
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Please enter last name en" />
                  </Form.Item>
                </Col>
              </Row>
              {/* เพิ่มมาใหม่? */}
              <Form.Item
                id="mcc-input"
                label={<h4>Main Company Code</h4>}
                name="main_company_code"
              >
                <Input size="large" placeholder="Please enter main company code" />
              </Form.Item>
              <Form.Item
                id="mcn-input"
                label={<h4>Main Company Name</h4>}
                name="main_company_name"
              >
                <Input size="large" placeholder="Please enter main company name" />
              </Form.Item>

              <Form.Item
                id="BU"
                name="BU"
                label={<h4>Business Group</h4>}
                className="customValidation"
                rules={[
                  {
                    required: true,
                    message: 'Please enter business group',
                  },
                ]}
              >
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  size="large"
                  style={{ width: '100%' }}
                  placeholder="Please enter business group"
                  disabled={disablePage}
                  optionLabelProp="label"
                >
                  {/* กรณีที่มีการแก้ไขและค่าที่เลือกไว้เป็น Inactive */}
                  {stateDrawer === 'edit' &&
                    dataEdit &&
                    dataBU.find(
                      (item) =>
                        item.id === dataEdit.data.bu_id && item.status === 'Inactive',
                    ) && (
                      <Option
                        key={dataEdit.data.bu_id}
                        value={dataEdit.data.bu_id}
                        label={
                          dataBU.find((item) => item.id === dataEdit.data.bu_id).name
                        }
                        style={{ display: 'none' }} // ซ่อนจาก dropdown แต่ยังแสดงใน tag
                      >
                        {dataBU.find((item) => item.id === dataEdit.data.bu_id).name}{' '}
                        (Inactive)
                      </Option>
                    )}

                  {/* แสดงเฉพาะ option ที่มี status เป็น Active */}
                  {dataBU
                    .filter((item) => item.status === 'Active')
                    .map((item) => (
                      <Option key={item.id} value={item.id} label={item.name}>
                        {item.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item
                id="synce_bussiness_unit_name"
                name="synce_bussiness_unit_name"
                label={<h4>Business Unit</h4>}
              >
                <Input size="large" disabled />
              </Form.Item>
              <Form.Item
                id="Role"
                name="Role"
                label={<h4>{word['Role']}</h4>}
                className="customValidation"
                rules={[
                  {
                    required: true,
                    message: 'Please enter role',
                  },
                ]}
              >
                {/* <Input id="engName" size="large" placeholder="Please enter role" /> */}
                <Select
                  disabled={disablePage}
                  mode="multiple"
                  size="large"
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Please select role"
                  onChange={handleChangeSelectRole}
                >
                  {childrenRole.map((item) => (
                    <Option value={item.id} name={item.name}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                id="DefaultRole"
                name="DefaultRole"
                label={<h4>{word['Default_Role']}</h4>}
                className="customValidation"
                rules={[
                  {
                    required: true,
                    message: 'Please enter default role',
                  },
                ]}
              >
                <Select
                  disabled={disablePage ? true : disableSelectRole}
                  size="large"
                  style={{ width: '100%' }}
                  placeholder="Please select role"
                >
                  {childrenDefaultRole.map((item) => (
                    <Option value={item.value}>{item.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                id="Email"
                name="Email"
                label={<h4>{word['Email']}</h4>}
                className="customValidation"
                rules={[
                  {
                    type: 'email',
                    message: 'The input is not valid E-mail!',
                  },
                  {
                    required: true,
                    whitespace: true,
                    message: 'Please enter Email',
                  },
                ]}
              >
                <Input id="Email" size="large" placeholder="Please enter Email" />
              </Form.Item>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    // className="noneInputNumber"
                    id="Phone"
                    name="Phone"
                    className="customValidation"
                    label={<h4>{word['Phone']}</h4>}
                    rules={[
                      {
                        pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
                        message: 'Please your phone number 0-9',
                      },
                      {
                        required: true,
                        whitespace: true,
                        message: 'Please enter your phone',
                      },
                    ]}
                  >
                    <Input
                      //  type="number"
                      minLength={10}
                      size="large"
                      placeholder="Please enter phone"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    id="Languaue"
                    name="Languaue"
                    label={<h4>{word['Languaue']}</h4>}
                    className="customValidation"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Please enter languaue',
                      },
                    ]}
                  >
                    <Select
                      disabled={disablePage}
                      size="large"
                      placeholder="Please enter language"
                    >
                      <Option value="th">{word['Thai']}</Option>
                      {/* <Option value="ch">Chineses</Option> */}
                      <Option value="en">{word['English']}</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                name="account_type"
                label={
                  <Row style={{ flexDirection: 'column' }}>
                    <h4>User Type</h4>
                    <span style={{ color: '#7C7C84' }}>
                      {' '}
                      <span style={{ color: '#D21419' }}>*</span> For internal user the
                      password won't display and external user you can see the password
                      with marked.
                    </span>
                  </Row>
                }
              >
                <Radio.Group onChange={(e) => displayEffectUserType(e)}>
                  <Radio id="#radio-IN" value="IN">
                    Internal
                  </Radio>
                  <Radio id="#radio-EX" value="EX">
                    External
                  </Radio>
                </Radio.Group>
              </Form.Item>
              {displayPassword && (
                <Row style={{ flexDirection: 'column' }}>
                  <Form.Item
                    id="NewPassword"
                    name="NewPassword"
                    className="specialLabel"
                    label={
                      <Col style={{ width: '100%' }}>
                        <div style={{ paddingTop: 20 }}>
                          <h4 style={{ display: 'inline' }}>{word['New_Password']}</h4>
                          <h4
                            style={{
                              display: 'inline',
                              color: 'red',
                              fontFamily: 'Kanit',
                            }}
                          >
                            {'  *'}
                          </h4>
                        </div>
                        <div className="divLabel">
                          <p>
                            {word['Password_have_at_least_10_characters_and_strength']}
                          </p>
                        </div>
                      </Col>
                    }
                    hasFeedback
                    rules={[
                      {
                        // min: 8,
                        whitespace: stateDrawer == 'edit' ? false : true,
                        required: stateDrawer == 'edit' ? false : true,
                        message: 'Please enter password !',
                      },
                      {
                        validator: validatePassword,
                      },
                    ]}
                  >
                    <PasswordInput
                      placeholder="Please enter new password"
                      onChange={(e) => {
                        onChangePassword(e)
                      }}
                    />
                    {/* <Input.Password placeholder="Password" autoComplete="none" /> */}
                  </Form.Item>
                  <p
                    style={{
                      color: scorePassword.colorScore,
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: scorePassword.nameScore != '' ? -15 : 0,
                    }}
                  >
                    {scorePassword.nameScore}
                  </p>
                  <Form.Item
                    id="ConfirmPassword"
                    name="ConfirmPassword"
                    label={
                      <div>
                        <h4 style={{ display: 'inline' }}>{word['Confirm_Password']}</h4>
                        <h4
                          style={{ display: 'inline', color: 'red', fontFamily: 'Kanit' }}
                        >
                          {'  *'}
                        </h4>
                      </div>
                    }
                    dependencies={['NewPassword']}
                    hasFeedback
                    rules={[
                      {
                        whitespace: stateDrawer == 'edit' ? false : true,
                        required:
                          stateDrawer == 'edit'
                            ? checkPasswordEdit
                              ? true
                              : false
                            : true,
                        message: 'Please confirm password!',
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('NewPassword') === value) {
                            return Promise.resolve()
                          }
                          return Promise.reject(
                            new Error('The two passwords that you entered do not match!'),
                          )
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      className="anticonPass"
                      autoComplete="new-password"
                      name="Confirmpass"
                      size="large"
                      placeholder="Please enter confirm password"
                      iconRender={(visible) =>
                        visible ? (
                          <EyeOutlined style={{ color: '#7c7c84' }} />
                        ) : (
                          <EyeInvisibleOutlined style={{ color: '#7c7c84' }} />
                        )
                      }
                    />
                  </Form.Item>
                </Row>
              )}
              <Form.Item
                style={{ display: 'flex', flexDirection: 'row' }}
                id="StatusActive"
                name="StatusActive"
                label={<h4>{word['Status_Active']} :</h4>}
              >
                <Switch
                  disabled={disablePage}
                  style={{ marginLeft: 14, marginTop: -11 }}
                  defaultChecked={
                    stateDrawer == 'add'
                      ? true
                      : dataEdit == undefined
                        ? _
                        : dataEdit.data.status == 'Active'
                          ? true
                          : false
                  }
                />
              </Form.Item>
            </fieldset>
          </Form>
        )
    }
  }

  const getDataAccountList = async (page) => {
    const lengthBeforeData = dataAccountList.data?.length
    const currentPage = pagination.current
    let HandlePage = page

    if (page === 'delete' && currentPage !== 1 && lengthBeforeData === 1) {
      HandlePage = currentPage - 1
    } else if (page === undefined) {
      HandlePage = pagination.current
    } else {
      HandlePage = page === 'delete' ? pagination.current : page
    }
    setPagination((prev) => ({
      ...prev,
      current: HandlePage,
    }))

    await getResultAccountList({
      token: token,
      params: filterTarget,
      page: HandlePage,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataAccountList([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setPagination((prev) => ({
            ...prev,
            total: data.total_record,
          }))
          setDataAccountList(data)
          setIsLoading(false)
        } else {
          setDataAccountList([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataAccountList([])
        setIsLoading(false)
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getDataAccountList(1)
    }
  }, [token, filterTarget])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            className="mini-search-btn-admin"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            <SearchOutlined className="icon" />
            {word['Search']}
          </Button>
          <Button
            type="primary"
            className="mini-search-btn-admin-reset"
            onClick={() => handleReset(clearFilters, dataIndex)}
          >
            {word['Reset']}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),

    // onFilter: (value, record) =>
    //   record[dataIndex]
    //     ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
    //     : '',
    // render: (text) => (searchedColumn === dataIndex ? text : text),
  })
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (dataIndex === 'name') {
      setFilterTarget((prev) => ({ ...prev, name: selectedKeys[0] }))
    } else if (dataIndex === 'username') {
      setFilterTarget((prev) => ({ ...prev, username: selectedKeys[0] }))
    } else if (dataIndex === 'role') {
      setFilterTarget((prev) => ({ ...prev, role: selectedKeys[0] }))
    } else if (dataIndex === 'lastloginsearch') {
      setFilterTarget((prev) => ({ ...prev, last_login: selectedKeys[0] }))
    } else {
      setFilterTarget((prev) => ({ ...prev, status: selectedKeys[0] }))
    }
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }
  const handleReset = (clearFilters, dataIndex) => {
    if (dataIndex === 'name') {
      setFilterTarget((prev) => ({ ...prev, name: '' }))
    } else if (dataIndex === 'username') {
      setFilterTarget((prev) => ({ ...prev, username: '' }))
    } else if (dataIndex === 'role') {
      setFilterTarget((prev) => ({ ...prev, role: '' }))
    } else if (dataIndex === 'lastloginsearch') {
      setFilterTarget((prev) => ({ ...prev, last_login: '' }))
    } else {
      setFilterTarget((prev) => ({ ...prev, status: '' }))
    }
    clearFilters()
    setSearchText('')
  }

  const [dataUserList, setDataUserList] = useState([])

  useEffect(() => {
    if (dataAccountList?.data !== undefined) {
      const fetchData = async () => {
        const results = await Promise?.all(
          dataAccountList?.data?.map(async (item) => {
            if (!item?.pic_display.includes('cpfit')) {
              const response = await getFileSecurityFromApi({
                url: item?.pic_display,
                token,
              })
              const { data } = response
              const blobUrl = URL.createObjectURL(data)
              return { ...item, pic_display: blobUrl } // หรือจะเลือกใช้ property ที่คุณต้องการจาก API ก็ได้
            } else {
              return { ...item, pic_display: item.pic_display } // หรือจะเลือกใช้ property ที่คุณต้องการจาก API ก็ได้
            }
          }),
        )
        setDataUserList(results)
      }
      fetchData()
    }
  }, [dataAccountList?.data])

  const dataSource =
    dataUserList != []
      ? dataUserList.map((item) => {
        let lastloginsplit = item.lastlogin.split(' ')
        let arr = []
        arr.push(item.role)
        item.canbe_rolename.split(',').map((item2) => {
          if (item.role != item2) {
            arr.push(item2)
          }
        })
        let joinarr = arr.join(',')

        //date
        let aaaa = lastloginsplit[0].split('-')
        let bbbb = []
        bbbb.push(aaaa[2])
        bbbb.push(aaaa[1])
        bbbb.push(aaaa[0])
        let cccc = bbbb.join('/')
        return {
          id: item.id,
          name: [
            item.firstname + ' ' + item.lastname,
            item.firstname_th + ' ' + item.lastname_th,
          ],
          username: item.username,
          role: joinarr,
          lastlogin: item.lastlogin,
          lastloginsearch: cccc,
          status: item.status == 'NonActive' || item.status == 'InActive' ? 'InActive' : 'Active',
          data: item,
        }
      })
      : []

  const columns = [
    {
      title: <h5>{word['Name']}</h5>,
      dataIndex: 'name',
      sorter: (a, b) => a?.name[0]?.localeCompare(b?.name[0]),
      // width: 140,
      ellipsis: true,
      // align: 'center',
      ...getColumnSearchProps('name'),
      render: (text, record) => (
        <Space size="middle">
          <img
            className="imageStyle"
            src={record.data.pic_display}
            style={{ marginRight: 16 }}
          ></img>

          <p>{text[0]}</p>
          <p style={{ display: 'none' }}>{text[1]}</p>
        </Space>
      ),
    },
    {
      title: <h5>{word['Username']}</h5>,
      dataIndex: 'username',
      // width: 180,
      sorter: (a, b) => a.username.localeCompare(b.username),
      ellipsis: true,
      ...getColumnSearchProps('username'),
    },
    {
      title: <h5>{word['Role']}</h5>,
      dataIndex: 'role',
      width: 180,
      sorter: (a, b) => a.role.localeCompare(b.role),
      // ellipsis: true,
      ...getColumnSearchProps('role'),
      render: (text) => {
        // let arr = []
        // arr.push(text)
        // record.data.canbe_rolename.split(',').map((item) => {
        //   arr.push(item)
        // })
        let arr = text.split(',')

        return arr.map((item, index) => {
          if (index == 0) {
            return (
              <Tag style={{ borderRadius: 16 }} color="#6DB9FF">
                {item}
              </Tag>
            )
          } else {
            return (
              <Tag style={{ borderRadius: 16 }} color="rgba(18, 126, 195, 0.32)">
                {item}
              </Tag>
            )
          }
        })
      },
    },
    {
      title: <h5>{word['Last_login']}</h5>,
      dataIndex: 'lastlogin',
      sorter: (a, b) => a.lastlogin.localeCompare(b.lastlogin),
      ellipsis: true,
      ...getColumnSearchProps('lastloginsearch'),
      render: (text) => {
        if (text != '') {
          return text
        } else {
          return ' '
        }
      },
    },
    {
      title: <h5>{word['Status']}</h5>,
      dataIndex: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),
      ellipsis: true,
      ...getColumnSearchProps('status'),
    },
  ]

  const onFinish = (value) => {
    form.setFieldsValue({
      UserName: value.Username,
    })

    if (stateDrawer == 'add') {
      if (clickBack == false) {
        form.setFieldsValue({
          Company: null,
          Operation: null,
          SubOperation: null,
          CompanyAdvance: [],
          powerBI: [],
          Account_link: [],
        })
        form2.setFieldsValue({
          CompanyAdvance: [],
          Account_link: [],
        })
        setAccountLinkValue([])
        setCompanyAdvanceValue([])
      }
    } else {
      if (clickBack == false) {
        setDataSelectCompany(dataEdit.data.company_code)
        const splitIDCompanyAdvance = String(dataEdit.data.access_comid || '').split(',')
        const companyAdvance = []

        splitIDCompanyAdvance.forEach((item) => {
          dataOptionCompanyMapping.forEach((company) => {
            if (company.id == item) {
              companyAdvance.push(company.code)
            }
          })
        })

        const list_company_array = dataEdit.company_list
        const getIDLinkCompany = list_company_array?.map((item) => item.company_code)

        form.setFieldsValue({
          Company: dataEdit.data.company_code + ' ' + dataEdit.data.companyname_th,
          Operation: dataEdit.data.operation_code + ' ' + dataEdit.data.operationname_th,
          SubOperation:
            dataEdit.data.suboperation_code + ' ' + dataEdit.data.suboperationname_th,
          Account_link: getIDLinkCompany,
          CompanyAdvance: companyAdvance,
        })
        form2.setFieldsValue({
          CompanyAdvance: companyAdvance,
          Account_link: getIDLinkCompany,
        })
        setAccountLinkValue(getIDLinkCompany)
        setCompanyAdvanceValue(companyAdvance)
      }
    }

    value.Role.map((item) => {
      getPermissionControl({
        token: token,
      })
        .then(async (response) => {
          const { status, data, error } = response
          if (error) {
            return true
          }
          if (status === 200) {
            if (data.result?.permission == null) {
            } else {
              data.result?.permission.map((item2) => {
                if (item2.menu_id == 6 || item2.menu_id == 7) {
                  setVisibleAdvance(true)
                }
                if (item2.menu_id == 22) {
                  setVisiblePoverBI(true)
                }
              })
            }
          } else {
            return true
          }
        })
        .catch((error) => {
          console.error(error)
        })
    })

    handleSelect(3)
    setDataUser(value)
  }

  const onFinish2 = (value) => {
    let canberolejoin = dataUser.Role.join(',')

    const mainBusinessSelection = getActiveMainBusinessSelection(value)
    if (mainBusinessSelection.isChanged) {
      clearInactiveMainBusinessSelection(mainBusinessSelection)
      setClickSave(false)
      return
    }

    const companyCode = getSelectCode(value.Company)
    let company_id = ''
    dataOptionCompany.map((item) => {
      if (item.code == companyCode) {
        company_id = item.id
      }
    })

    const activeCompanyAdvance = getActiveCompanyAdvance(value.CompanyAdvance || [])
    let arrAdvanceCompany = []
    activeCompanyAdvance.map((item) => {
      dataOptionCompanyMapping.map((item2) => {
        if (item2.code == item) {
          arrAdvanceCompany.push(item2.id)
        }
      })
    })

    const operationCode = getSelectCode(value.Operation)
    const suboperationCode = getSelectCode(value.SubOperation)

    const operation_id = dataOptionOperation.find((f) => f.code === operationCode)
    const suboperation_id = dataOptionSubOperation.find(
      (f) => f.code === suboperationCode,
    )
    let splittoday = today.split('-')
    let expiredyear = 5
    let arr = [parseInt(splittoday[0]) + expiredyear, splittoday[1], splittoday[2]]
    let expired_at = arr.join('-')

    if (clickSave == true) {
      setClickSave(false)
      if (stateDrawer === 'add') {
        const data = {
          account_type: dataUser.account_type,
          main_company_name: dataUser.main_company_name,
          main_company_code: dataUser.main_company_code,
          username: dataUser.Username,
          password: dataUser?.NewPassword,
          code: dataUser.Name,
          firstname: dataUser.Name,
          lastname: dataUser.LastName,
          firstname_th: dataUser.Name_TH,
          lastname_th: dataUser.Lastname_TH,
          phone: dataUser.Phone,
          email: dataUser.Email,
          company_id: company_id,
          operation_id: operation_id?.id,
          suboperation_id: suboperation_id?.id,
          role_id: dataUser.DefaultRole,
          canbe_role: canberolejoin,
          bu_id: dataUser.BU,
          lang: dataUser.Languaue,
          status: dataUser.StatusActive == true ? 'Y' : 'N',
          expired_at: `${expired_at} 23:59:59`,
          access_comid: arrAdvanceCompany.join(','),
        }
        try {
          addAccount({
            params: data,
            token: token,
          }).then(async (res) => {
            const { status, data } = res
            if (status === 200) {
              await updateCompanyLinkByUserID(value.Account_link, data)
              setClickBack(false)
              form.setFieldsValue({
                Company: null,
                Operation: null,
                SubOperation: null,
                CompanyAdvance: [],
              })
              if (fileUpload) {
                const data = new FormData()
                data.append('uploadfile', fileUpload)
                data.append('account_id', res.data.id)
                try {
                  saveImageAccount({
                    params: data,
                    token: token,
                  }).then((res) => {
                    if (res.status === 200) {
                      getDataAccountList(pagination.current)
                      setHiddenError(true)
                      setVisible(false)
                    } else {
                      setClickBack(true)
                      handleSelect(1)
                      setWordError(word['Failed_to_upload_pictures'])
                      setHiddenError(false)
                    }
                  })
                } catch (error) {
                  console.log(error)
                }
              } else {
                getDataAccountList(pagination.current)
                setHiddenError(true)
                setVisible(false)
              }
            } else {
              handleSelect(1)
              setWordError(word['email_already_exists'])
              setHiddenError(false)
              setClickBack(true)
              var Cerror = res.data.errorCode
              if (['2012', '2007', '2023'].includes(Cerror)) {
                setPasswordError(res.data.errorCode)
                setPassmessagevisinle(false)
              }
            }
          })
        } catch (error) {
          console.log(error)
        }
      } else {
        const data = {
          account_type: dataUser.account_type,
          main_company_name: dataUser.main_company_name,
          main_company_code: dataUser.main_company_code,
          username: dataUser.Username,
          code: 'CP1443',
          firstname: dataUser.Name,
          lastname: dataUser.LastName,
          firstname_th: dataUser.Name_TH,
          lastname_th: dataUser.Lastname_TH,
          phone: dataUser.Phone,
          email: dataUser.Email,
          company_id: company_id || dataEdit?.data?.company_id || '',
          operation_id: operation_id?.id,
          suboperation_id: suboperation_id?.id,
          role_id: dataUser.DefaultRole,
          canbe_role: canberolejoin,
          bu_id: dataUser.BU,
          lang: dataUser.Languaue,
          status: dataUser.StatusActive == true ? 'Y' : 'N',
          expired_at: `${expired_at} 23:59:59`,
          access_comid: arrAdvanceCompany.join(','),
        }

        try {
          editAccountV2({
            id: dataEdit.id,
            params: data,
            token: token,
          }).then(async (res) => {
            const { status, data } = res
            if (status === 200) {
              await updateCompanyLinkByUserID(value.Account_link, data)
              if (userID == dataEdit.id) {
                childrenRole.map((item) => {
                  if (item.id == dataUser.DefaultRole) {
                    setCookie('roleUser', item.id)
                    setCookie('roleNameDefault', item.name)
                    getPermissionAdmin()
                  }
                })
              }

              if (dataUser?.NewPassword != '' && dataUser?.NewPassword != null) {
                const data = {
                  account_id: dataEdit.id,
                  old: '',
                  new: dataUser?.NewPassword,
                  page: 'admin',
                }
                try {
                  changePassword({
                    params: data,
                    token: token,
                  }).then((res) => {
                    if (res.status === 200) {
                      setHiddenError(true)
                      getDataAccountList(pagination.current)
                      setVisible(false)
                      setPassmessagevisinle(true)
                    } else {
                      var Cerror = res.data.errorCode
                      if (['2012', '2007', '2023'].includes(Cerror)) {
                        setPasswordError(res.data.errorCode)
                        setPassmessagevisinle(false)
                        handleSelect(1)
                      }
                    }
                  })
                } catch (error) {
                  console.log(error)
                }
              } else {
                setHiddenError(true)
                getDataAccountList(pagination.current)
                setVisible(false)
              }
            } else {
              setClickBack(true)
              handleSelect(1)
              setWordError(word['email_already_exists'])
              setHiddenError(false)
            }
          })
        } catch (error) {
          console.log(error)
        }
      }
    } else {
      handleSelect(1)
    }
  }

  const updateCompanyLinkByUserID = async (isMultiLink, responsedataUser) => {
    // to do post method
    const getIDUser = responsedataUser.id
    const selectedCompanyLinks = Array.isArray(isMultiLink) ? isMultiLink : []
    const activeCompanyLinks = getActiveAccountLinks(selectedCompanyLinks)
    const getcomIDList = dataOptionCompany
      .filter((item) => activeCompanyLinks.includes(item.code))
      .map((company) => {
        return company.id
      })
    const joinArray_companyIDLink = getcomIDList.length > 0 ? getcomIDList.join(',') : ''

    const params = {
      account_id: parseInt(getIDUser),
      company_list: String(joinArray_companyIDLink),
    }

    try {
      await updateCompanyLink({ params, token })
    } catch (error) {
      console.log(error)
    }
  }

  const normalizeCompanyLinkItem = (item = {}) => {
    return {
      ...item,
      company_id: item.company_id || item.id,
      company_code: item.company_code || item.code,
      company_name_en: item.company_name_en || item.companyname_en || item.name_en || '',
      company_name_th: item.company_name_th || item.companyname_th || item.name_th || '',
    }
  }

  const fetchApiCompanyWithLink = async (accountId) => {
    const getdata = await getCompanyWithLinkV2({
      token,
      status: 'all',
      accountId,
    })
      .then(async (response) => {
        if (Array.isArray(response)) {
          return response.map((item) => normalizeCompanyLinkItem(item))
        }
        if (Array.isArray(response?.data)) {
          return response.data.map((item) => normalizeCompanyLinkItem(item))
        }
        if (Array.isArray(response?.data?.result)) {
          return response.data.result.map((item) => normalizeCompanyLinkItem(item))
        }
        return []
      })
      .catch((error) => {
        console.error(error)
        return []
      })
    return getdata
  }

  const getDataRoleList = async () => {
    await getResultRoleList({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setChildrenRole([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setChildrenRole(data)
          setIsLoading(false)
        } else {
          setChildrenRole([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setChildrenRole([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getDataBU = async () => {
    await getResultBUV2({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataBU([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataBU(data.result)

          setIsLoading(false)
        } else {
          setDataBU([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataBU([])
        setIsLoading(false)
        console.error(error)
      })
    setIsLoading(false)
  }

  const eventAdd = () => {
    setMainBusinessErrors({})
    setScorePassword({ nameScore: '', colorScore: '' })
    // setDataPowerBI()
    setClickBack(false)
    getDataRoleList()
    getDataBU()
    handleSelect(1)
    setState({
      imageUrl: null,
    })
    form.setFieldsValue({
      BU: null,
      ConfirmPassword: null,
      Email: null,
      Languaue: null,
      LastName: null,
      Name: null,
      Lastname_TH: null,
      Name_TH: null,
      NewPassword: null,
      Phone: null,
      Role: [],
      DefaultRole: null,
      Username: null,
      StatusActive: true,
      Account_link: [],
      main_company_code: null,
      main_company_name: null,
      account_type: 'IN',
      synce_bussiness_unit_name: null,
    })
    form2.setFieldsValue({
      CompanyAdvance: [],
      Account_link: [],
    })
    setAccountLinkValue([])
    setCompanyAdvanceValue([])
    setDisplayPassword(false)

    setUserLock(false)
    setClickSave(false)
    setDisableSelectOperation(true)
    setDisableSelectSubOperation(true)
    setDisableSelectAdvance(true)
    setHiddenError(true)
    setVisible(true)
    //>>> new config
    setPassmessagevisinle(true)
    // new config <<<
    setStateDrawer('add')
    setTitleDrawer('Add User')

    setDisableNext(false)
    setCheckPasswordEdit('')
  }

  const eventAddExport = () => {
    form3.setFieldsValue({
      Company: 'all company',
      Operation: null,
      SubOperation: null,
    })
    setDisableSelectOperation(true)
    setDisableSelectSubOperation(true)
    setVisibleExport(true)
  }

  const openNotificationWithIcon = (type, message, data) => {
    notification[type]({
      message: message,
      description: data,
      duration: 3,
    })
  }

  const onClickUnLock = () => {
    const data = {
      id: parseInt(dataEdit.id),
    }
    try {
      accountUnLock({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status == 200) {
          GetAccountByID(dataEdit)
          openNotificationWithIcon(
            'success',
            'Successfully',
            'Unlock user account has been completed.',
          )
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const GetAccountByID = async (data) => {
    return getAccountByIdV2({
      token: token,
      id: data.id,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setIsLoading(false)
          return null
        }
        if (status === 200) {
          setUserLock(data.userlock == 'Y' ? true : false)
          setIsLoading(false)
          return data
        }

        setIsLoading(false)
        return null
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
        return null
      })
  }

  const eventEdit = async (data) => {
    setMainBusinessErrors({})
    setScorePassword({ nameScore: '', colorScore: '' })
    permissionPage.update ? setDisablePage(false) : setDisablePage(true)
    setClickBack(false)
    getDataRoleList()
    getDataBU()
    handleSelect(1)
    setClickSave(false)
    setDisableSelectOperation(false)
    setDisableSelectSubOperation(false)
    setDisableSelectAdvance(false)
    setHiddenError(true)
    setDisableSelectRole(false)
    // setDataPowerBI()

    const accountDetail = await GetAccountByID(data.data)
    const editData = accountDetail || data.data

    let splitcanberole = editData.canbe_role.split(',')
    let arr = []
    splitcanberole.map((item) => {
      item == '' ? _ : arr.push(parseInt(item))
    })
    let splitcanberolename = editData.canbe_rolename.split(',')

    let arr2 = []
    for (let index = 0; index < arr.length; index++) {
      arr2.push({ value: arr[index], name: splitcanberolename[index] })
    }

    setChildrenDefaultRole(arr2)
    form.setFieldsValue({
      // BU: editData.bu_id,
      BU: editData.bu_id !== '' && editData.bu_id !== 0 ? editData.bu_id : null,
      ConfirmPassword: null,
      Email: editData.email,
      Languaue: editData.lang,
      LastName: editData.lastname,
      Name: editData.firstname,
      Lastname_TH: editData.lastname_th,
      Name_TH: editData.firstname_th,
      NewPassword: null,
      Phone: editData.phone,
      Role: arr,
      // DefaultRole:  editData.role_id ,
      DefaultRole:
        editData.role_id !== '' && editData.role_id !== 0 ? editData.role_id : null,
      Username: editData.username,
      StatusActive: editData.status == 'Active' ? true : false,
      main_company_code: editData.main_company_code,
      main_company_name: editData.main_company_name,
      account_type: editData.account_type,
      // synce_bussiness_unit_name: editData?.sync_business_unit
      //   ? language == 'en'
      //     ? editData.sync_business_unit.name_en
      //     : editData.sync_business_unit.name
      //   : null,
      synce_bussiness_unit_name: editData?.sync_business_unit
        ?  editData.sync_business_unit.name
        : null,
    })

    if (editData.account_type === 'IN') {
      setDisplayPassword(false)
    } else {
      setDisplayPassword(true)
    }
    setState({
      imageUrl: editData.pic_display,
    })
    let nameUrlfile = editData.pic_display.split('/')
    let logoname = nameUrlfile[nameUrlfile.length - 1]
    setlogoName(logoname.split('?')[0])

    // const userCompanyLinkList = await fetchApiCompanyLink(data.id)
    const userCompanyLinkList = await fetchApiCompanyWithLink(editData.id)

    const addJoinUserData = {
      ...data,
      data: editData,
      company_list: userCompanyLinkList,
    }
    setDataEdit(addJoinUserData)
    setStateDrawer('edit')
    setTitleDrawer(word['Edit_User'])
    setVisible(true)
    //>>> new config
    setPassmessagevisinle(true)
    // new config <<<
    setDisableNext(false)
    setCheckPasswordEdit('')
  }
  const [clickSave, setClickSave] = useState(false)
  const [clickBack, setClickBack] = useState(false)

  const onClickSave = () => {
    setClickSave(true)
    form.submit()
  }
  const renderButton_Drawer = (state) => {
    if (state == 'adduser') {
      if (stateDrawer === 'add') {
        return (
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button
              className="BTN_Next"
              onClick={() => {
                onClickSave()
              }}
              disabled={disableNext}
            >
              {OneUnitFocus == 1 ? 'Next' : 'Save'}
            </Button>
          </div>
        )
      } else {
        return (
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button
              className="BTN_Delete_CPF_RED"
              onClick={() => setVisibleDelete(true)}
              style={{ marginRight: 8 }}
              hidden={permissionPage.delete ? false : true}
              id="delete_user_btn"
            >
              {word['Delete']}
            </Button>
            <Button
              hidden={permissionPage.update ? false : true}
              className="BTN_Next"
              onClick={() => {
                onClickSave()
              }}
              disabled={disableNext}
            >
              {OneUnitFocus == 1 ? word['Next'] : word['Save']}
            </Button>
          </div>
        )
      }
    } else if (state == 'export') {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button className="BTN_Next" onClick={form3.submit}>
            {word['Export']}
          </Button>
        </div>
      )
    }
  }

  const onClose = () => {
    setMainBusinessErrors({})
    setVisible(false)
  }
  const onCloseExport = () => {
    setVisibleExport(false)
  }
  function onChangePage(val) {
    getDataAccountList(val)
  }

  const content = () => {
    return (
      <Container>
        <Header className="layout-button-add-normal-state">
          <div className="layout-btn-reset-add">
            <div style={{ marginRight: 8 }}>
              {/* <a href="https://cpfit-nonprod.s3-ap-southeast-1.amazonaws.com/iproject_alpha/99999/29/template_account_import.xlsx"> */}
              <a href="https://cpfit-uat.s3-ap-southeast-1.amazonaws.com/iproject_uat/9999999/29/template_import_account.xlsx">
                <Button
                  id="templeteuser"
                  icon={<DownloadOutlined className="Icon-color" />}
                  className="BTN_Next"
                  hidden={permissionPage.create ? false : true}
                >
                  {word['Templete']}
                </Button>
              </a>
            </div>

            <Button
              id="importuser"
              onClick={() => setVisibleModal(true)}
              icon={<PlusOutlined className="Icon-color" />}
              className="BTN_Next"
              hidden={permissionPage.create ? false : true}
            >
              {word['Import_User']}
            </Button>
            <Button
              id="exportuser"
              onClick={eventAddExport}
              style={{ marginLeft: 8 }}
              icon={<PlusOutlined className="Icon-color" />}
              className="BTN_Next"
            >
              {word['Export_User']}
            </Button>
            <Button
              id="adduser"
              onClick={eventAdd}
              style={{ marginLeft: 8 }}
              icon={<PlusOutlined className="Icon-color" />}
              className="BTN_Next"
              hidden={permissionPage.create ? false : true}
            >
              {word['Add_User']}
            </Button>

            <Button
              id="reset"
              type="primary"
              style={{ marginLeft: 8 }}
              className="btn_Secondary2"
              onClick={() => window.location.reload()}
            >
              <RedoOutlined className="Icon-color" />
              {word['Reset']}
            </Button>
          </div>
        </Header>
        <Body>
          <Table
            key="business_table"
            onRow={(record) => {
              return {
                onClick: () => eventEdit(record), // click row
              }
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            showSorterTooltip={false}
          />
          <Pagination
            style={{ marginTop: 16 }}
            className="pagination"
            current={pagination.current}
            defaultCurrent={pagination.current}
            total={pagination.total}
            pageSize={pagination.pageSize}
            onChange={onChangePage}
            showSizeChanger={false}
          />
        </Body>
      </Container>
    )
  }

  const handleChange = (info) => {
    getBase64(info.file.originFileObj, (imageUrl) =>
      setState({
        imageUrl,
      }),
    )

    setlogoName(info.file.name)
  }
  const { imageUrl } = state

  function getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  const [fileUpload, setFileUpload] = useState()

  const logoUpload = (file) => {
    const data = new FormData()
    data.append('uploadfile', file)
    data.append(
      'account_id',
      stateDrawer == 'add'
        ? dataAccountList.data[dataAccountList.data.length - 1].id + 1
        : dataEdit.id,
    )

    setFileUpload(file)

    if (stateDrawer == 'edit') {
      try {
        saveImageAccount({
          params: data,
          token: token,
        }).then((res) => {
          getDataAccountList(pagination.current)
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const uploadButton = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img className="logo-upload" src={ellipse}></img>
      <EditUpload
        className="avatar-upload-container"
        action={logoUpload}
        name="uploadfile"
        listType="picture-card"
        showUploadList={false}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        disabled={disablePage}
      >
        <p style={{ color: '#127ec3' }}>{word['Click_to_upload_image']}</p>
      </EditUpload>
    </div>
  )

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!')
    }
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!')
    }
    return isJpgOrPng && isLt2M
  }

  //option
  const [dataOptionCompany, setDataOptionCompany] = useState([])
  const [dataOptionCompanyMapping, setDataOptionCompanyMapping] = useState([])

  const [dataOptionOperation, setDataOptionOperation] = useState([])
  const [dataOptionSubOperation, setDataSubOptionOperation] = useState([])
  const [mainBusinessErrors, setMainBusinessErrors] = useState({})

  const [disableSelectOperation, setDisableSelectOperation] = useState(true)
  const [disableSelectSubOperation, setDisableSelectSubOperation] = useState(true)

  const getOptionCompany = async () => {
    await getDataCompany({
      token: token,
      level: 1,
      level_id: 0,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataOptionCompany([])

          return true
        }
        if (status === 200) {
          setDataOptionCompany(data)
        } else {
          setDataOptionCompany([])

          return true
        }
      })
      .catch((error) => {
        setDataOptionCompany([])
        console.error(error)
      })
  }

  const getOptionCompanyMapping = async () => {
    await getDataCompany_Level_v2({
      token: token,
      level: 1,
      level_id: 0,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataOptionCompanyMapping([])
          return true
        }
        if (status === 200) {
          setDataOptionCompanyMapping(data)
        } else {
          setDataOptionCompanyMapping([])
          return true
        }
      })
      .catch((error) => {
        setDataOptionCompanyMapping([])
        console.error(error)
      })
  }

  const getOptionOperation = async (idcompany) => {
    await getDataCompany({
      token: token,
      level: 2,
      level_id: idcompany,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataOptionOperation([])

          return true
        }
        if (status === 200) {
          setDataOptionOperation(data)
        } else {
          setDataOptionOperation([])

          return true
        }
      })
      .catch((error) => {
        setDataOptionOperation([])

        console.error(error)
      })
  }

  //getDataOption
  const getOptionSubOperation = async (idoperation) => {
    await getDataCompany({
      token: token,
      level: 3,
      level_id: idoperation,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataSubOptionOperation([])

          return true
        }
        if (status === 200) {
          setDataSubOptionOperation(data)
        } else {
          setDataSubOptionOperation([])

          return true
        }
      })
      .catch((error) => {
        setDataSubOptionOperation([])
        console.error(error)
      })
  }

  const getCurrentCompanyCode = (companyCode) => {
    const companyValue =
      companyCode || form2.getFieldValue('Company') || form.getFieldValue('Company')

    if (typeof companyValue === 'string') {
      return companyValue.split(' ')[0]
    }

    return companyValue || dataSelectCompany
  }

  const isInactiveCompany = (company) => {
    return String(company?.status || '').toLowerCase() === 'inactive'
  }

  const isActiveOption = (option) => {
    if (!option) return false
    return String(option?.status || '').toLowerCase() !== 'inactive'
  }

  const getSelectCode = (value) => {
    if (typeof value === 'string') {
      return value.split(' ')[0]
    }

    return value
  }

  const findOptionByCode = (options = [], code) => {
    const selectedCode = getSelectCode(code)
    return options.find((item) => item?.code == selectedCode)
  }

  const getActiveMainBusinessSelection = (value) => {
    const companyCode = getSelectCode(value.Company)
    const operationCode = getSelectCode(value.Operation)
    const suboperationCode = getSelectCode(value.SubOperation)
    const selectedCompany = findOptionByCode(dataOptionCompany, companyCode)
    const selectedOperation = findOptionByCode(dataOptionOperation, operationCode)
    const selectedSubOperation = findOptionByCode(
      dataOptionSubOperation,
      suboperationCode,
    )

    if (!isActiveOption(selectedCompany)) {
      return {
        isChanged: Boolean(companyCode || operationCode || suboperationCode),
        Company: null,
        Operation: null,
        SubOperation: null,
        requiredFields: ['Company', 'Operation', 'SubOperation'],
      }
    }

    if (!isActiveOption(selectedOperation)) {
      return {
        isChanged: Boolean(operationCode || suboperationCode),
        Company: companyCode,
        Operation: null,
        SubOperation: null,
        requiredFields: ['Operation', 'SubOperation'],
      }
    }

    if (!isActiveOption(selectedSubOperation)) {
      return {
        isChanged: Boolean(suboperationCode),
        Company: companyCode,
        Operation: operationCode,
        SubOperation: null,
        requiredFields: ['SubOperation'],
      }
    }

    return {
      isChanged: false,
      Company: companyCode,
      Operation: operationCode,
      SubOperation: suboperationCode,
      requiredFields: [],
    }
  }

  const clearInactiveMainBusinessSelection = (selection) => {
    form.setFieldsValue({
      Company: selection.Company,
      Operation: selection.Operation,
      SubOperation: selection.SubOperation,
    })
    form2.setFieldsValue({
      Company: selection.Company,
      Operation: selection.Operation,
      SubOperation: selection.SubOperation,
    })
    setMainBusinessErrors(getRequiredMainBusinessErrors(selection.requiredFields || []))

    if (!selection.Company) {
      setDataSelectCompany()
      setDataOptionOperation([])
      setDataSubOptionOperation([])
      setDisableSelectOperation(true)
      setDisableSelectSubOperation(true)
      return
    }

    if (!selection.Operation) {
      setDataSubOptionOperation([])
      setDisableSelectSubOperation(true)
      return
    }

    setDisableSelectOperation(false)
    setDisableSelectSubOperation(false)
  }

  const getCompanyCode = (company = {}) => {
    return company.company_code || company.code
  }

  const getCompanyLabel = (company = {}) => {
    const companyCode = getCompanyCode(company)
    const companyName =
      language == 'en'
        ? company.company_name_en || company.companyname_en || company.name_en
        : company.company_name_th || company.companyname_th || company.name_th

    return `${companyCode} ${companyName || ''}`
  }

  const getActiveAccountLinks = (value = [], companyCode) => {
    const selectedCompanyCode = getCurrentCompanyCode(companyCode)
    const inactiveCompanyCodes = (dataEdit?.company_list || [])
      .filter((item) => isInactiveCompany(item))
      .map((item) => item.company_code || item.code)
    const activeCompanyCodes = dataOptionCompany
      .filter((item) => item.code != selectedCompanyCode && !isInactiveCompany(item))
      .map((item) => item.code)

    return value.filter((accountLinkCode) =>
      activeCompanyCodes.includes(accountLinkCode) &&
      !inactiveCompanyCodes.includes(accountLinkCode),
    )
  }

  const getActiveCompanyAdvance = (value = [], companyCode) => {
    const selectedCompanyCode = getCurrentCompanyCode(companyCode)
    const companyOptions =
      dataOptionCompanyMapping.length > 0 ? dataOptionCompanyMapping : dataOptionCompany
    const activeCompanyCodes = companyOptions
      .filter((item) => item.code != selectedCompanyCode && !isInactiveCompany(item))
      .map((item) => item.code)

    return value.filter((companyCode) => activeCompanyCodes.includes(companyCode))
  }

  const getRequiredMainBusinessErrors = (fields = []) => {
    const requiredMessageByField = {
      Company: 'Please enter business',
      Operation: 'Please enter operation',
      SubOperation: 'Please enter project type',
    }

    return fields.reduce((result, field) => {
      result[field] = requiredMessageByField[field]
      return result
    }, {})
  }

  const clearMainBusinessErrors = (fields = []) => {
    setMainBusinessErrors((prev) => {
      const next = { ...prev }
      fields.forEach((field) => {
        delete next[field]
      })
      return next
    })
  }

  const onChangeAccountLink = (value = []) => {
    const nextAccountLink = getActiveAccountLinks(value)

    setAccountLinkValue(nextAccountLink)
    form.setFieldsValue({
      Account_link: nextAccountLink,
    })
    form2.setFieldsValue({
      Account_link: nextAccountLink,
    })
  }

  const onChangeCompanyAdvance = (value = []) => {
    const nextCompanyAdvance = getActiveCompanyAdvance(value)

    setCompanyAdvanceValue(nextCompanyAdvance)
    form.setFieldsValue({
      CompanyAdvance: nextCompanyAdvance,
    })
    form2.setFieldsValue({
      CompanyAdvance: nextCompanyAdvance,
    })
  }

  useEffect(() => {
    if (
      visible == true &&
      stateDrawer == 'edit' &&
      dataEdit &&
      switchAddTaskComponents == 'company' &&
      dataOptionCompanyMapping.length > 0
    ) {
      const currentCompanyAdvance = form2.getFieldValue('CompanyAdvance') || []

      if (currentCompanyAdvance.length == 0) {
        const splitIDCompanyAdvance = String(dataEdit.data.access_comid || '').split(',')
        const companyAdvance = []

        splitIDCompanyAdvance.forEach((item) => {
          dataOptionCompanyMapping.forEach((company) => {
            if (company.id == item) {
              companyAdvance.push(company.code)
            }
          })
        })

        if (companyAdvance.length > 0) {
          form.setFieldsValue({
            CompanyAdvance: companyAdvance,
          })
          form2.setFieldsValue({
            CompanyAdvance: companyAdvance,
          })
          setCompanyAdvanceValue(companyAdvance)
        }
      }
    }
  }, [visible, stateDrawer, dataEdit, switchAddTaskComponents, dataOptionCompanyMapping])

  useEffect(() => {
    if (visible == true) {
      // getOptionPowerBI()
      getOptionCompany()
      getOptionCompanyMapping()
      if (stateDrawer == 'edit') {
        getOptionOperation(dataEdit.data.company_id)
        getOptionSubOperation(dataEdit.data.operation_id)
        // getDataSetFieldPowerBI(dataEdit.data.id)
      }
    }
  }, [visible])

  useEffect(() => {
    if (visibleExport == true) {
      getOptionCompany()
      getOptionOperation()
      getOptionSubOperation()
    }
  }, [visibleExport])

  const onChangeCompany = async (value) => {
    clearMainBusinessErrors(['Company', 'Operation', 'SubOperation'])
    if (value == 'all company') {
      setDisableSelectOperation(true)
      setDisableSelectSubOperation(true)
    } else {
      const nextAccountLink = getActiveAccountLinks(
        form2.getFieldValue('Account_link') || form.getFieldValue('Account_link') || [],
        value,
      )
      form.setFieldsValue({
        Operation: null,
        SubOperation: null,
        CompanyAdvance: [],
        Account_link: nextAccountLink,
      })
      form2.setFieldsValue({
        Operation: null,
        SubOperation: null,
        CompanyAdvance: [],
        Account_link: nextAccountLink,
      })
      setAccountLinkValue(nextAccountLink)
      setCompanyAdvanceValue([])
      form3.setFieldsValue({
        Operation: null,
        SubOperation: null,
      })
      if (value) {
        setDataSelectCompany(value)
        dataOptionCompany.map((item) => {
          if (item.code == value) {
            getOptionOperation(item.id)
          }
        })

        setDisableSelectOperation(false)
        setDisableSelectAdvance(false)
      } else {
        setDisableSelectOperation(true)
        setDisableSelectSubOperation(true)
        setDisableSelectAdvance(true)
        setDataOptionOperation([])
        setDataSubOptionOperation([])
      }
    }
  }

  const onChangeOperation = async (value) => {
    clearMainBusinessErrors(['Operation', 'SubOperation'])
    form.setFieldsValue({
      SubOperation: null,
    })
    form3.setFieldsValue({
      SubOperation: null,
    })
    if (value) {
      dataOptionOperation.map((item) => {
        if (item.code == value) {
          getOptionSubOperation(item.id)
        }
      })
      setDisableSelectSubOperation(false)
    } else {
      setDisableSelectSubOperation(true)
      setDataSubOptionOperation([])
    }
  }

  const onFinishExport = (value) => {
    setVisibleExport(false)
    setIsLoading(true)
    let company_id = ''
    dataOptionCompany.map((item) => {
      if (item.code == value.Company) {
        company_id = item.id
      }
    })

    let operation_id = ''
    dataOptionOperation.map((item) => {
      if (item.code == value.Operation) {
        operation_id = item.id
      }
    })

    let suboperation_id = ''
    dataOptionSubOperation.map((item) => {
      if (item.code == value.SubOperation) {
        suboperation_id = item.id
      }
    })

    const data = {
      company_id: `${company_id}`,
      operation_id: `${operation_id}`,
      suboperation_id: `${suboperation_id}`,
    }

    try {
      exportAccount({
        params: data,
        token: token,
      }).then(async (res) => {
        if (res.status === 200) {
          await getFileSecurityFromApi({ url: res.data.path, token }).then((response) => {
            const href = window.URL.createObjectURL(response.data)
            const anchorElement = document.createElement('a')
            anchorElement.href = href
            anchorElement.download = res?.data?.filename || 'download'
            document.body.appendChild(anchorElement)
            anchorElement.click()
            document.body.removeChild(anchorElement)
            window.URL.revokeObjectURL(href)
          })
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }

  const onClickTabs = (value) => {
    if (disableNext != true) {
      setClickSave(false)
      if (value != OneUnitFocus) {
        form.submit()
      }

      if (stateDrawer == 'edit') {
        if (value == 1 && OneUnitFocus == 3) {
          setClickBack(true)
        }
      } else {
        setClickBack(true)
      }
    }
  }

  return (
    <BusinessContainer
      style={{ padding: 32 }}
      className="layout-git-master-unitmeasurment"
    >
      {isLoading ? (
        <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
          <img src={loadingIcons}></img>
        </div>
      ) : (
        content()
      )}

      <Modal
        maskClosable={false}
        title={<TextTitleBold>{titleDrawer}</TextTitleBold>}
        placement="right"
        onCancel={onClose}
        visible={visible}
        width={'634px'}
        className="fix-modal"
        footer={renderButton_Drawer('adduser')}
        destroyOnClose
      >
        <Bodier className="Bodier2" style={{ marginTop: 16 }}>
          <div className="tab">
            <div
              id="user"
              className={mode && OneUnitFocus == 1 ? 'Tabbar' : 'active-Tabbar'}
              onClick={() => onClickTabs(1)}
            >
              <h3>{word['User']}</h3>
            </div>
            <div
              id="linkcompany"
              className={mode && OneUnitFocus == 3 ? 'Tabbar' : 'active-Tabbar'}
              onClick={() => onClickTabs(3)}
            >
              <h3>{word['Link_Business']}</h3>
            </div>
          </div>
        </Bodier>
        <div style={{ marginTop: 32 }}>{renderComponents()}</div>
        <DeleteAccount
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          data={dataEdit}
          setCheckChangeTable={getDataAccountList}
          state="usermanagement"
          setVisbleDrawer={setVisible}
        />
      </Modal>

      <Modal
        maskClosable={false}
        title={<TextTitleBold>{word['Export_User']}</TextTitleBold>}
        placement="right"
        onCancel={onCloseExport}
        visible={visibleExport}
        width={'634px'}
        className="fix-modal"
        bodyStyle={{ paddingBottom: 80 }}
        footer={renderButton_Drawer('export')}
        destroyOnClose
        centered
      >
        <Form
          className="disable-page"
          form={form3}
          layout="vertical"
          onFinish={onFinishExport}
        >
          <Form.Item id="Company" name="Company" label={<h4>{word['Business']}</h4>}>
            <Select
              id="selectcompany_code"
              size="large"
              placeholder="Business Code"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={onChangeCompany}
            >
              <Option value={'all company'}>{word['All_Business']}</Option>
              {dataOptionCompany.map((item) => (
                <Option value={item.code}>
                  {item.code} {language == 'en' ? item.name_en : item.name_th}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item id="Operation" name="Operation" label={<h4>{word['Operation']}</h4>}>
            <Select
              id="selectoperation_code"
              size="large"
              placeholder="Operation Code"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={onChangeOperation}
              disabled={disableSelectOperation}
            >
              {dataOptionOperation.map((item) => (
                <Option value={item.code}>
                  {item.code} {language == 'en' ? item.name_en : item.name_th}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            id="SubOperation"
            name="SubOperation"
            label={<h4>{word['Sub_Operation']}</h4>}
          >
            <Select
              id="selectsub_operation_code"
              size="large"
              placeholder="Project type Code"
              allowClear
              showSearch
              optionFilterProp="children"
              disabled={disableSelectSubOperation}
            >
              {dataOptionSubOperation.map((item) => (
                <Option value={item.code}>
                  {item.code} {language == 'en' ? item.name_en : item.name_th}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      <Importfile
        visible={visibleModal}
        setVisible={setVisibleModal}
        state="User"
        getResultDataHolidayDetail={getDataAccountList}
      ></Importfile>
    </BusinessContainer>
  )
}
export default UserManagement
